import React, { useRef } from "react";
import { useUscSelector } from "../../../../redux/store";
import { UscLabel, useUscLabel } from "../../../../utils/labels";
import AccessoryItem from "./AccessoryItem";
import { useScrollSnap } from "../../../../../../common-deprecated/hooks/useScrollSnap";
import { useBreakpoint } from "../../../../../../common-deprecated/themes/common";
import Text from "../../styles/atoms/Text";
import Icon from "../../styles/Icon";
import Button from "../../styles/atoms/Button";
import * as Styles from "./Accessories.styles";
import { trackAccessorySliderClick } from "../../../../utils/tracking";

const Accessories = (): JSX.Element | null => {
    const [titleLabel, ariaSlidePreviousLabel, ariaSlideNextLabel] = useUscLabel([
        "uscPdpAccessoriesTitle",
        "uscAriaSlidePrevious",
        "uscAriaSlideNext",
    ]);
    const accessories = useUscSelector((state) => state.accessories.accessoryResults);
    const uscContext = useUscSelector((state) => state.vehicle.type);
    const sliderViewport = useRef<HTMLDivElement>(null);
    const isMobile = useBreakpoint("down", "sm");
    const useSlider = isMobile ? accessories.length > 1 : accessories.length > 2;

    const { handleChange, addNode, reachedStart, reachedEnd } = useScrollSnap({
        sliderRef: sliderViewport,
        disableDesktopDragging: true,
        itemCount: accessories.length,
        scrollAmount: isMobile ? 1 : 2,
        disabled: !useSlider,
        interactionTrack: () => trackAccessorySliderClick(uscContext),
    });

    if (!accessories.length) return null;

    return (
        <Styles.Wrapper>
            <Text tag="h3" variant="h6">
                {titleLabel}
            </Text>
            <Styles.SliderWrapper>
                <Styles.SliderViewport ref={sliderViewport}>
                    {accessories.map((accessory, index) => (
                        <AccessoryItem
                            key={accessory.id}
                            accessory={accessory}
                            index={index}
                            ref={(node) => addNode(node, index)}
                        />
                    ))}
                </Styles.SliderViewport>
            </Styles.SliderWrapper>
            {useSlider && (
                <Styles.NavigationBar>
                    <Text tag="div" variant="body-book">
                        <UscLabel
                            label={
                                accessories.length > 1
                                    ? "uscPdpAccessoriesSliderCount"
                                    : "uscPdpAccessoriesSliderCountSingle"
                            }
                            params={{
                                count: accessories.length,
                            }}
                        />
                    </Text>
                    <Styles.ButtonWrapper>
                        <Button
                            variant="control"
                            disabled={reachedStart}
                            onClick={(evt) =>
                                handleChange(evt as React.MouseEvent<HTMLButtonElement, MouseEvent>, "left")
                            }
                            aria-label={ariaSlidePreviousLabel}
                        >
                            <Icon variant="chevron-left" />
                        </Button>
                        <Button
                            variant="control"
                            disabled={reachedEnd}
                            onClick={(evt) =>
                                handleChange(evt as React.MouseEvent<HTMLButtonElement, MouseEvent>, "right")
                            }
                            aria-label={ariaSlideNextLabel}
                        >
                            <Icon variant="chevron-right" />
                        </Button>
                    </Styles.ButtonWrapper>
                </Styles.NavigationBar>
            )}
        </Styles.Wrapper>
    );
};

export default Accessories;
